"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./style.css");
class Tab extends _react.default.Component {
  constructor(props) {
    super(props);
    const {
      activeTabIndex
    } = this.props;
    this.state = {
      activeTab: activeTabIndex
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle(tab) {
    this.setState({
      activeTab: tab
    });
  }
  render() {
    const {
      activeTab
    } = this.state;
    const {
      tabItems,
      justified
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "ixn-tab ".concat(justified ? 'tabs-justified' : 'tabs-auto')
    }, /*#__PURE__*/_react.default.createElement(_reactstrap.Nav, {
      tabs: true,
      className: "ixn-tab__navigation-tabs"
    }, tabItems.map((ref, index) => {
      return /*#__PURE__*/_react.default.createElement(_reactstrap.NavItem, {
        key: index,
        className: "ixn-tab__navigation-item"
      }, /*#__PURE__*/_react.default.createElement(_reactstrap.NavLink, {
        role: "navigation-link",
        "aria-label": ref.title,
        className: (0, _classnames.default)({
          'active': activeTab === index
        }, 'ixn-tab__navigation-link'),
        onClick: () => {
          this.toggle(index);
          ref === null || ref === void 0 || ref.callbackHandler();
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ixn-tab__navigation-link__title"
      }, ref.title), ref.isBadge && /*#__PURE__*/_react.default.createElement(_reactstrap.Badge, {
        className: "ixn-tab__badge",
        pill: true
      }, ref.badgeValue)));
    })), /*#__PURE__*/_react.default.createElement(_reactstrap.TabContent, {
      activeTab: activeTab,
      className: "ixn-tab__tabs-content"
    }, tabItems.map((item, index) => {
      return /*#__PURE__*/_react.default.createElement(_reactstrap.TabPane, {
        key: index,
        tabId: index
      }, /*#__PURE__*/_react.default.createElement(_reactstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
        sm: "12"
      }, item.content)));
    })));
  }
}
exports.Tab = Tab;
Tab.defaultProps = {
  justified: false,
  activeTabIndex: 0,
  tabItems: [{
    title: 'Tab1',
    content: "Tab1 content",
    isBadge: true,
    badgeValue: 300,
    callbackHandler: () => {}
  }, {
    title: 'Tab2',
    content: "Tab2 content",
    isBadge: true,
    badgeValue: 25,
    callbackHandler: () => {}
  }]
};
Tab.propTypes = {
  /** Contains array with list of objects which shows the tabs */
  tabItems: _propTypes.default.array,
  /** It equally adjust the tab size to underline viewport */
  justified: _propTypes.default.bool
};